import { createRoute } from '@tanstack/react-router';

import { TravelerViewPage } from '@web/ui/traveler_view';

import { orgRoute } from './org_routes';

/**
 * `/orgs/$orgSlug/conversations/$conversationId` — the traveler view the
 * Zendesk handoff ticket links to. A direct child of `orgRoute` (like
 * `settings`), outside the workspace shell: full screen, no org sidebar, still
 * behind login and org membership.
 */
export const travelerViewRoute = createRoute({
  getParentRoute: () => orgRoute,
  path: 'conversations/$conversationId',
  component: TravelerViewPage,
});
